import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDoc } from "../hooks/useDoc";

const RecomendacionDetalle = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { data: recomendacion, loading } = useDoc('recomendaciones', slug);

  if (loading) return <section className="section"><div className="container"><p>Cargando...</p></div></section>;
  if (!recomendacion) return <section className="section"><div className="container"><p>Recomendación no encontrada</p></div></section>;

  return (
    <section className="section">
      <div className="container">
        <button onClick={() => navigate(-1)} className="form-button" style={{ marginBottom: "1.5rem" }}>
          ← Volver
        </button>

        <figure className="section-image-wrapper">
          <img src={recomendacion.imagen} alt={recomendacion.titulo} className="section-image" />
          {recomendacion.epigrafe && (
            <figcaption className="section-image-caption">{recomendacion.epigrafe}</figcaption>
          )}
        </figure>

        <h2 className="section-title">{recomendacion.titulo}</h2>
        <p className="contact-heading">{recomendacion.descripcionCorta}</p>

        <div className="taller-detalle-texto">
          {recomendacion.descripcionLarga.split(/\n\s*\n/).map((p, i) => <p key={i}>{p}</p>)}
        </div>
      </div>
    </section>
  );
};

export default RecomendacionDetalle;
